import PricebookWizard from "./PricebookWizard";

export default PricebookWizard;



// WEBPACK FOOTER //
// ./src/components/Pricebook/PricebookWizard/index.js